import React,{useState} from 'react'
import { SketchPicker } from 'react-color'
import "./ColorPicker.css"
// import { rgba2hex } from'../../Resources/globalFunctions.js'
import ControlsMap from '../../components/Properties/PropertiesConfiguration'
import {useTranslation} from 'react-i18next';
import rgbHex from "rgb-hex";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CustomizedAlert from '../Alert/CustomizedAlert.jsx'

export default function ColorPicker(props) {
    const { t } = useTranslation();
    const {color, handleProperty, propertyName, sketchPickerCustomStyle,fromGradient}=props;
   
    function isColor(strColor){
        var s = new Option().style;
        s.color = strColor;
        var test1 = s.color == strColor;
        var test2 = /^#[0-9A-F]{6}$/i.test(strColor);
        var test3 = /^#[0-9A-F]{8}$/i.test(strColor);

        if(test1 == true || test2 == true || test3 == true) {
            return strColor;
        } 
        else {
            var color3 = `#${strColor}`;
            var s2 = new Option().style;
            s2.color = color3;
            var test4 = s2.color == color3;
            var test5 = /^#[0-9A-F]{6}$/i.test(color3);
            var test6 = /^#[0-9A-F]{8}$/i.test(color3);
            if(test4 == true || test5 == true || test6 == true) {
                return color3;
            }
            else {
                return "";
            }
        }
    }

    const [colorSet,setColorSet]=useState({
        color: color,
        show: props?.show1 !== undefined ? props?.show1 : false
    });

    const [currColor, setCurrColor] = useState(color);

    const [alertData, setAlertData] = useState({
        open: false,
        showConfirm: "showNotification"
    });
    
    const colorStyle={
        backgroundColor:colorSet.color,
    }

    var customIconStyle = {};
    if(props.customIconStyle){
        customIconStyle  = props.customIconStyle ;
    }

    const handleChange=(color, update = true)=>{
        const {r, g, b, a}=color.rgb;
        let hexColor =""
        if(a=== 1) {
            hexColor= "#" + rgbHex(r,g,b); 
        } else {
         hexColor= "#" + rgbHex(r,g,b,a); 
        }

        setColorSet((prev)=>{return {...prev, color: hexColor, show: true}});
        setCurrColor(hexColor)
        if(update) {
            handleProperty(propertyName,hexColor);
        }
    }

    const handleChangeByInput=(e)=>{
        let colorValue=isColor(e.target.value);
        if(colorValue === "") {
            setCurrColor(colorSet.color);
            setAlertData({
                showConfirm: "showNotification",
                open: true,
                alertContentKey: `Invalid Value for color`,
                alertType: "error",
                autoHideDuration: 5000,
            });
            return;
        }
        setColorSet((prev)=>{return{...prev,color:colorValue, show: true}});
        var s = new Option().style;
        s.color = colorValue;        
        if(s.color!==undefined){
            handleProperty(propertyName,colorValue);
        }
    }

    const handleOnchangeInput = (e) => {
        let colorValue = e.target.value;
        setCurrColor(colorValue);
    }
    
    return (
        <>
         <ClickAwayListener onClickAway={()=>{
            if(colorSet.show) {
                setColorSet((prev)=>{return{...prev,show:false}})
            }
        }}>
            {props?.show1 !== undefined ?
        <div>         
            {colorSet.show && 

             <span className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? `sketchPickerStyleArabic` : fromGradient ? `sketchPickerStyleGradient` : `sketchPickerStyle`} style={props.colorPickerInnerBoxStyle ? props.colorPickerInnerBoxStyle : null}> 
            <span style={sketchPickerCustomStyle} >
                    <SketchPicker color={isColor(colorSet.color)} onChange={(color) => handleChange(color, false)} onChangeComplete={(color)=>handleChange(color)} presetColors={props.presetColors}/>      
                </span>
            </span> }
            <input aria-label={"Color Value"} className="inputStyle" style={props.colorPickerInputStyle ? props.colorPickerInputStyle : null} placeholder={currColor} value={currColor} onChange={handleOnchangeInput} onBlur={(e)=>handleChangeByInput(e)} />         
        </div>
        :
        <div className={"colorParentDiv"} style={props && props.colorPickerParentDiv}
        >
            
            <span className="colorStyle" style={props.colorPickerInnerBoxStyle ?{...colorStyle,  ...props.colorPickerInnerBoxStyle, ...customIconStyle} : colorStyle} onClick={()=>setColorSet((prev)=>{return{...prev, show: true}})}></span>
            {colorSet.show && 
            <span className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? `sketchPickerStyleArabic` : fromGradient ? `sketchPickerStyleGradient` : `sketchPickerStyle`} style={props.colorPickerInnerBoxStyle ? props.colorPickerInnerBoxStyle : null}> 
            <span style={sketchPickerCustomStyle} >
                    <SketchPicker color={isColor(colorSet.color)} onChange={(color) => handleChange(color, false)} onChangeComplete={(color)=>handleChange(color)} presetColors={props.presetColors}/>      
                </span>
            </span> }
            <input  className="inputStyle" aria-label='Input Style' style={props.colorPickerInputStyle ? props.colorPickerInputStyle : null} placeholder={currColor} value={currColor} onChange={handleOnchangeInput} onBlur={(e)=>handleChangeByInput(e)} />
            
        </div>
        }
        </ClickAwayListener>
        { alertData.open === true &&
            <CustomizedAlert alertData={alertData} />
        }
        </>
    )
}

